import { render } from "./D03Details.vue?vue&type=template&id=a40eabd8&scoped=true&ts=true"
import script from "./D03Details.vue?vue&type=script&lang=ts"
export * from "./D03Details.vue?vue&type=script&lang=ts"

import "./D03Details.vue?vue&type=style&index=0&id=a40eabd8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a40eabd8"]])

export default __exports__